import React from "react";

export const CourseInfo = ({
  language, 
  key,
  title,
  institution,
  date,
  url
}) => {
     
  let text = "";
  if (language === "English") {
    text = "My Certification";
  } else if (language === "Spanish") {
    text = "Mi Certificación";
  } 

  return (
    <div id="courses">
        <h1 id="coursesInfo"><span id="coursesTitle"> <strong>{title}</strong>.</span> {institution}, {date}.         <a href={url} target="_blank">{text} </a>
       </h1>    
    </div>
  );
};

export default CourseInfo;